import {
  Box,
  createStyles,
  InputLabel,
  makeStyles,
  Slider,
  Theme,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

interface OwnProps {
  label?: string;
  value: number[];
  valueCaption?: string;
  minAllowed?: number;
  maxAllowed?: number;
  onChange: (value: number[]) => void;
}

export default function InputRangeSlider({
  minAllowed,
  maxAllowed,
  onChange,
  label,
  value,
  valueCaption,
}: OwnProps) {
  const classes = useStyles();
  const [state, setState] = useState<number[]>(value);

  useEffect(() => {
    if (value !== state) {
      setState(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Box className={classes.sliderBox}>
      <InputLabel>{label}</InputLabel>
      <Slider
        className={classes.root}
        value={state}
        onChange={handleChange}
        onChangeCommitted={handleOnChangeCommitted}
        valueLabelDisplay="auto"
        min={minAllowed}
        max={maxAllowed}
        aria-labelledby="range-slider"
        getAriaValueText={valueText}
      />
      <Box className={classes.sliderCaptionBox}>
        <Typography variant="caption">
          {minAllowed}
          {valueCaption ?? valueCaption}
        </Typography>
        <Typography variant="caption">
          {maxAllowed}
          {valueCaption ?? valueCaption}
        </Typography>
      </Box>
    </Box>
  );

  function handleChange(_: any, newValue: number[] | number) {
    setState(newValue as number[]);
  }

  function handleOnChangeCommitted(_: any, newValue: number[] | number) {
    onChange(newValue as number[]);
  }

  function valueText(value: number) {
    return value.toString();
  }
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.divider,
      height: 3,
      padding: '13px 0',
    },
    sliderBox: {
      paddingLeft: '8px',
      paddingRight: '4px',
    },
    sliderCaptionBox: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: '-4px',
      marginRight: '-4px',
      marginTop: '-10px',
    },
  }),
);
